import { omit } from 'lodash'
export const WhiteLink = (props) => (<a className={`content-primary-white text-decoration-none ${props.className || ""}`} {...omit(props, "children")}>{props.children}</a>);
export const UnderlinedWhiteLink = (props) => (<a className="content-primary-white" {...omit(props, "children")}>{props.children}</a>);
export const ImageLink = ({ src, alt, href, className }) => (<a href={href} className="mr-16">
    <img src={src} alt={alt} className={className || ""} />
</a>);